import React from 'react';
import { Form } from 'react-bootstrap';
import { FieldValues, FieldErrors, UseFormRegister, UseFormSetValue, FormState, PathValue, Path } from 'react-hook-form';

interface FormGroupProps<T extends FieldValues> {
    controlId: string;
    label: string;
    name: Path<T>;
    type?: string;
    autoComplete?: string;
    register: UseFormRegister<T>;
    formState: FormState<T>;
    errors: FieldErrors<T>;
    setValue: UseFormSetValue<T>;
}

const FormGroup = <T extends FieldValues>({
    controlId,
    label,
    name,
    type = 'text',
    autoComplete,
    register,
    formState,
    errors,
    setValue,
}: FormGroupProps<T>) => {
    const isTouched = formState.touchedFields[name as keyof typeof formState.touchedFields]; // Type assertion
    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...register(name)}
                name={String(name)}
                type={type}
                autoComplete={autoComplete}
                isValid={isTouched && !errors[name]}
                isInvalid={isTouched && !!errors[name]}
                onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setValue(name, e.target.value as PathValue<T, Path<T>>, {
                        shouldValidate: true,
                        shouldTouch: true,
                    });
                }}
            />
            <Form.Control.Feedback type="invalid">
                {errors[name]?.message as string}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export default FormGroup;